"use client";

// @ts-strict-ignore
import styled from "styled-components";
import Button from "components/parts/button";
import { Col, Grid, Row } from "components/layout/Grid";
import LightBackground from "components/pages/Institutions/images/background-light-blue.png";
import NextImage from "components/parts/NextImage";

export const GetStartedButton = styled(Button)`
  margin-top: 40px;
`;

export const InnerContainer = styled.div`
  display: block;
  margin: 0 auto 80px;
  padding-left: 5%;
  padding-right: 5%;
  max-width: 1368px;

  ${({ theme: { media } }) => media.giantDesktop`
    margin: 0 auto ${({ noMargins }) => (noMargins ? "0" : "0")};
  `}

  flex-grow: 1;

  button {
    width: 190px;
    height: 60px;

    ${({ theme: { media } }) => media.tablet`
      width: 260px;
    `};
  }
`;

export const Container = styled.main`
  width: 100%;
  margin-top: 120px;
`;

export const CryptoSec = styled(Grid)`
  padding: 10% 0;
  position: relative;
  ${({ theme: { media } }) => media.desktop`
    padding: 5% 0;
  `};
`;

export const CryptoSecPicture = styled(NextImage)`
  position: absolute;
  top: -45px;
  float: none;
  ${({ theme: { media } }) => media.tablet`
      position: initial;
      width: 110px;
      height: 110px;
      margin-right: 50px;
      margin-bottom: 32px;
    `};
  ${({ theme: { media } }) => media.desktop`
      position: initial;
      width: 180px;
      height: 180px;
      margin-right: 50px;
      margin-bottom: 0;
    `};
`;

export const CryptoSecText = styled.div`
  margin: 30px 0 15px 0;
  max-width: 1100px;

  ${({ theme: { media } }) => media.tablet`
    margin: 0;
  `};
`;

export const ImageCol = styled(Col)`
  padding-top: 50px;
  ${({ theme: { media } }) => media.desktop`
    padding-top: 0;
  `};
`;

export const HeroRow = styled(Row)`
  margin-top: 0;
  padding: 30px 0 50px 0;
  ${({ theme: { media } }) => media.desktop`
    padding-top: 80px;
  `};
`;

export const AffinityLeadFormContainer = styled.div`
  background: url(${LightBackground});
  position: absolute;
`;
